import { useTranslation } from 'react-i18next';
import Dialog from '../../../../../../../common/widgets/Dialog';
import Icons from '../../../../../../../common/widgets/Icons';
import { resources } from '../../../../../resources/resources';

interface SaveSuccesDialog {
  close: () => void;
}

export default function SaveSuccessDialog(props: Readonly<SaveSuccesDialog>) {
  const { t: translate } = useTranslation();
  const { close } = props;
  return (
    <Dialog
      closeDialog={() => close()}
      showCloseIcon
      closeOnClickOutside
      className="dialog-s"
    >
      <div className="dialog-content">
        <div className="dialog-image">
          <Icons.Success />
        </div>
        <div className="dialog-title">
          {translate(resources.admin.employees.add.saveSuccessDialog.congrats)}
        </div>
        <div className="dialog-text centered">
          {translate(resources.admin.employees.add.saveSuccessDialog.message)}
        </div>
      </div>
      <div className="dialog-actions vertical">
        <button className="btn btn-outline" onClick={() => close()}>
          {translate(resources.admin.employees.add.saveSuccessDialog.close)}
        </button>
      </div>
    </Dialog>
  );
}
